import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetDuplicateInfoByLead } from 'cpool-tables/backend-resolvers';

import { useAggregateInfiniteQuery } from '~/queryUtils/useQuery';
import { useQueryPositionStore } from '~/store/queryPositionStore.ts';
import { queryKeys } from '~/utils/queryKeys.ts';

const PAGE_SIZE = 20;

export const useDuplicateLeadsInfiniteQuery = (loanRequestId: string) => {
    const queryKey = queryKeys.duplicateLeads(loanRequestId);
    const queryPosition = useQueryPositionStore((state) => state.positions[JSON.stringify(queryKey)]);

    const result = useAggregateInfiniteQuery({
        acl: { loanRequestId },
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        pageSize: PAGE_SIZE,
        resolverName: LOAN_REQUEST_RESOLVERS.getDuplicateInfoByLead,
        schema: schemaLoanRequestResolver_GetDuplicateInfoByLead,
        searchParams: { loanRequestId, position: queryPosition },
    });

    return {
        data: result.data?.pages.flat() ?? [],
        fetchNextPage: result.fetchNextPage,
        hasNextPage: result.hasNextPage,
        isFetching: result.isFetching,
        isFetchingNextPage: result.isFetchingNextPage,
        isLoading: result.isLoading,
    };
};
